// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from "react";

const TEAM_REPORTS = [
  { name:"Jordan Lutz", role:"Lead Developer",
    accomplishments:["Completed HVAC workflow module for Vantage Ops","Implemented rate limiting for API v3","Fixed 3 UI bugs reported from VitaSync beta","Code reviewed auth module refactor"],
    challenges:["GlowDesk recording pages behind schedule","Real-time notifications WebSocket testing delayed"],
    nextWeek:["Complete WebSocket notification system","Start plumbing workflow module","GlowDesk recording pages"],
    tasksCompleted:12, hoursLogged:42, meetings:4 },
  { name:"Ryan Miskulin", role:"CEO",
    accomplishments:["Completed Q1 board presentation","Approved Phase 2 budget for Canstorr partnership","Conducted 3 client meetings","Reviewed and approved Q1 hiring plan"],
    challenges:["Need to finalize domain purchase budget","Insurance broker pitch deck still pending"],
    nextWeek:["Finalize Q1 strategic priorities","Meet with Western Mining leadership","Review PolicyForge progress"],
    tasksCompleted:8, hoursLogged:45, meetings:7 },
  { name:"Taylor Schenher", role:"CFO",
    accomplishments:["Finalized Q1 revenue forecast model","Completed Q4 financial reconciliation","Approved marketing budget allocation","Submitted board financial slides"],
    challenges:["Revenue projections need adjustment for mining vertical delay"],
    nextWeek:["Present Q1 forecast to leadership","Review employee benefits renewal","Prepare investor update materials"],
    tasksCompleted:6, hoursLogged:38, meetings:3 },
  { name:"Lucas Mason", role:"VP of Sales",
    accomplishments:["Conducted 3 product demos","Created Q1 sales roadmap","Advanced Canstorr deal to proposal stage","Launched insurance broker email campaign"],
    challenges:["Cattle Ranch Collective unresponsive after 3 attempts","Need updated sales collateral for mining vertical"],
    nextWeek:["BC Insurance Group demo on Feb 14","Follow up with Metro Beauty trial","Prepare Northern Fleet assessment"],
    tasksCompleted:10, hoursLogged:40, meetings:6 },
  { name:"Des Bachynski", role:"Health Ambassador",
    accomplishments:["Completed Prairie Health staff training (12 users)","Compiled beta feedback from 3 clinics","Updated health compliance documentation"],
    challenges:["2026 regulatory changes require additional compliance updates","Need more time with pilot clinic feedback"],
    nextWeek:["Address remaining compliance gaps","Schedule 2-week clinic check-ins","Prepare advanced training materials"],
    tasksCompleted:5, hoursLogged:36, meetings:2 },
  { name:"Lee Mehling", role:"Canadian Ambassador",
    accomplishments:["Conducted Western Mining product demo","Completed mining site visit report","Started compliance requirements research"],
    challenges:["Mining requirements gathering taking longer than expected","Need site visits to all 3 mine sites"],
    nextWeek:["Send mining compliance checklist","Schedule follow-up demo with IT team","Continue requirements gathering"],
    tasksCompleted:4, hoursLogged:35, meetings:3 },
  { name:"Clorice Robertson", role:"Chief Accounting Officer",
    accomplishments:["Completed January AR reconciliation","Distributed board meeting minutes","Processed January expense reports"],
    challenges:["Employee benefits renewal deadline approaching"],
    nextWeek:["Start benefits package comparison","Prepare February payroll","Review Q1 budget vs actuals"],
    tasksCompleted:5, hoursLogged:38, meetings:2 },
  { name:"Tyson Becker", role:"Commodities Ambassador",
    accomplishments:["Completed AgriTech sensor installation","Conducted Canstorr quarterly review","Ordered Phase 2 sensor hardware"],
    challenges:["Rural connectivity issues at some farm sites","Sensor calibration needs fine-tuning for cold weather"],
    nextWeek:["Monitor AgriTech sensor data","Schedule Canstorr installation dates","Follow up with Cattle Ranch lead"],
    tasksCompleted:6, hoursLogged:44, meetings:3 },
  { name:"Tyler Hodgson", role:"Operations",
    accomplishments:["Compiled VitaSync beta feedback report","Designed new Overwatch KPI widgets","Started security pen test scope document"],
    challenges:["Overwatch backend API development needs support"],
    nextWeek:["Complete pen test scope document","Implement Overwatch dashboard enhancements","Research provincial compliance for fleet"],
    tasksCompleted:5, hoursLogged:37, meetings:3 }
];

const PAST_REPORTS = [
  { id:1, week:"Feb 3 - Feb 7, 2026", status:"Current", submittedBy:"Ryan Miskulin" },
  { id:2, week:"Jan 27 - Jan 31, 2026", status:"Submitted", submittedBy:"Ryan Miskulin" },
  { id:3, week:"Jan 20 - Jan 24, 2026", status:"Submitted", submittedBy:"Ryan Miskulin" },
  { id:4, week:"Jan 13 - Jan 17, 2026", status:"Submitted", submittedBy:"Ryan Miskulin" }
];

export default function WeeklyReportPage() {
  const [reports] = useState(TEAM_REPORTS);
  const [selectedMember, setSelectedMember] = useState(null);

  const totalTasks = reports.reduce((sum, r) => sum + r.tasksCompleted, 0);
  const totalHours = reports.reduce((sum, r) => sum + r.hoursLogged, 0);
  const totalMeetings = reports.reduce((sum, r) => sum + r.meetings, 0);
  const totalChallenges = reports.reduce((sum, r) => sum + r.challenges.length, 0);

  return (
    <div>
      <div className="page-header">
        <div><h1 className="page-title">Weekly Report</h1><p>Week of Feb 3 - Feb 7, 2026</p></div>
        <button className="btn btn-primary">Submit Report</button>
      </div>

      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Tasks Completed</div><div className="stat-value" style={{color:"#10b981"}}>{totalTasks}</div></div>
        <div className="stat-card"><div className="stat-label">Hours Logged</div><div className="stat-value">{totalHours}</div></div>
        <div className="stat-card"><div className="stat-label">Deals Closed</div><div className="stat-value" style={{color:"#3b82f6"}}>2</div></div>
        <div className="stat-card"><div className="stat-label">Meetings Held</div><div className="stat-value">{totalMeetings}</div></div>
      </div>

      {/* Team Summary */}
      <div className="card">
        <div className="card-header"><h3>Team Summary</h3><span style={{fontSize:12,color:"#64748b"}}>{reports.length} members</span></div>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>
            <tr style={{borderBottom:"2px solid #334155"}}>
              {["Team Member","Role","Tasks Done","Hours","Meetings","Accomplishments","Challenges"].map(h => (
                <th key={h} style={{textAlign:"left",padding:"10px 8px",fontSize:12,fontWeight:700,color:"#94a3b8"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {reports.map(r => (
              <tr key={r.name} style={{borderBottom:"1px solid #334155",cursor:"pointer"}} onClick={() => setSelectedMember(r)}>
                <td style={{padding:"10px 8px",fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{r.name}</td>
                <td style={{padding:"10px 8px",fontSize:12,color:"#94a3b8"}}>{r.role}</td>
                <td style={{padding:"10px 8px",fontSize:13,fontWeight:600,color:"#10b981"}}>{r.tasksCompleted}</td>
                <td style={{padding:"10px 8px",fontSize:13,color:"#e2e8f0"}}>{r.hoursLogged}</td>
                <td style={{padding:"10px 8px",fontSize:13,color:"#e2e8f0"}}>{r.meetings}</td>
                <td style={{padding:"10px 8px",fontSize:13,color:"#10b981"}}>{r.accomplishments.length}</td>
                <td style={{padding:"10px 8px",fontSize:13,color:r.challenges.length>0?"#eab308":"#64748b"}}>{r.challenges.length}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selectedMember && (
        <div className="modal-overlay" onClick={() => setSelectedMember(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{selectedMember.name} - Weekly Report</h2>
              <button className="modal-close" onClick={() => setSelectedMember(null)}>X</button>
            </div>
            <div className="modal-body">
              <div style={{display:"flex",gap:12,marginBottom:16}}>
                <span className="badge badge-purple">{selectedMember.role}</span>
                <span style={{fontSize:13,color:"#94a3b8"}}>{selectedMember.tasksCompleted} tasks | {selectedMember.hoursLogged}h | {selectedMember.meetings} meetings</span>
              </div>

              <div style={{marginBottom:16}}>
                <h4 style={{fontSize:13,fontWeight:700,color:"#10b981",marginBottom:8}}>Accomplishments</h4>
                {selectedMember.accomplishments.map((a, i) => (
                  <div key={i} style={{display:"flex",gap:8,padding:"4px 0"}}><span style={{color:"#10b981"}}>&#10003;</span><span style={{fontSize:13,color:"#e2e8f0"}}>{a}</span></div>
                ))}
              </div>

              <div style={{marginBottom:16}}>
                <h4 style={{fontSize:13,fontWeight:700,color:"#eab308",marginBottom:8}}>Challenges</h4>
                {selectedMember.challenges.length > 0 ? selectedMember.challenges.map((c, i) => (
                  <div key={i} style={{display:"flex",gap:8,padding:"4px 0"}}><span style={{color:"#eab308"}}>!</span><span style={{fontSize:13,color:"#e2e8f0"}}>{c}</span></div>
                )) : <p style={{fontSize:13,color:"#64748b"}}>No challenges reported</p>}
              </div>

              <div>
                <h4 style={{fontSize:13,fontWeight:700,color:"#3b82f6",marginBottom:8}}>Plan for Next Week</h4>
                {selectedMember.nextWeek.map((n, i) => (
                  <div key={i} style={{display:"flex",gap:8,padding:"4px 0"}}><span style={{color:"#3b82f6"}}>&#8594;</span><span style={{fontSize:13,color:"#e2e8f0"}}>{n}</span></div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Key Highlights */}
      <div className="grid-2" style={{marginTop:16}}>
        <div className="card">
          <div className="card-header"><h3 style={{color:"#10b981"}}>Key Accomplishments</h3></div>
          {["VitaSync beta testing with 3 clinics completed","HVAC module for Vantage Ops finished","Q1 revenue forecast model finalized","AgriTech sensor installation completed","3 successful product demos conducted"].map((a, i) => (
            <div key={i} style={{display:"flex",gap:8,padding:"6px 0",borderBottom:"1px solid #334155"}}><span style={{color:"#10b981"}}>&#10003;</span><span style={{fontSize:13,color:"#e2e8f0"}}>{a}</span></div>
          ))}
        </div>
        <div className="card">
          <div className="card-header"><h3 style={{color:"#eab308"}}>Challenges & Blockers</h3></div>
          {["GlowDesk recording pages behind schedule","Mining requirements gathering taking longer","Rural connectivity issues at farm sites","Overwatch backend API needs support","Insurance broker pitch deck still pending"].map((c, i) => (
            <div key={i} style={{display:"flex",gap:8,padding:"6px 0",borderBottom:"1px solid #334155"}}><span style={{color:"#eab308"}}>!</span><span style={{fontSize:13,color:"#e2e8f0"}}>{c}</span></div>
          ))}
        </div>
      </div>

      {/* Past Reports */}
      <div className="card" style={{marginTop:16}}>
        <div className="card-header"><h3>Past Reports</h3></div>
        {PAST_REPORTS.map(r => (
          <div key={r.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:"1px solid #334155"}}>
            <div><div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{r.week}</div><div style={{fontSize:11,color:"#64748b"}}>Submitted by {r.submittedBy}</div></div>
            <span className={r.status==="Current"?"badge badge-blue":"badge badge-green"}>{r.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
